<template>
  <div class="full-height">
    <crud-layout v-if="!measurementReportForm"
      ref="crudLayout"
      :name="name"
      :interface="nmInterface"
      :id="id"
      :page="page"
    />
    <billing-order-send-measurement-report v-else :forms="measurementReportForm" :format="measurementReportFormat" @on-close="onCloseReport"/>
    <q-dialog v-model="visible" persistent>
      <billing-order-report-selection
        :measurementReportParams="measurementReportParams"
        :measurementReportType="measurementReportType"
        :measurementReportFormat="measurementReportFormat"
        @generate-report="onGenerateReport"
      />
    </q-dialog>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import { repository } from 'jtech'
import BillingOrderPage from './BillingOrderPage'
import BillingOrderPageSearch from './BillingOrderPageSearch'
import BillingOrderSendMeasurementReport from '../report/BillingOrderSendMeasurementReport.vue'
import BillingOrderReportSelection from '../../../components/billingOrder/BillingOrderReportSelection.vue'
const CrudLayout = JtCrud.CrudLayout

@Component({
  name: 'BillingOrder',
  components: { CrudLayout, BillingOrderPage, BillingOrderSendMeasurementReport, BillingOrderReportSelection },
  props: {
    id: String,
    interface: String,
    name: String
  }
})
class BillingOrder extends Vue {
  datatableLocal = null;
  visible = false;
  row = null;
  dadosModal = { show: false };
  measurementReportForm = null;
  measurementReportFormat = 'pdf';
  measurementReportType = 'ANALYTICAL';
  forms = [];
  extraParam = {};
  ticketModal = { show: false }
  measurementReportParams = null;

  get nmInterface () {
    return this.interface
  }

  mounted () {
    try {
      this.$refs.crudLayout.onButton('report', this.actionButtonReport)
    } catch (error) {
    }
  }

  updated () {
    try {
      this.$refs.crudLayout.onButton('report', this.actionButtonReport)
    } catch (error) {
    }
  }

  onCloseReport () {
    this.measurementReportForm = null
  }

  actionButtonReport ({ button, params }) {
    this.visible = true
    this.measurementReportParams = { billingOrder: params.id, contractBillingType: params?.contractBillingType }
  }

  async onGenerateReport ({ measurementReportType, measurementReportFormat }) {
    this.measurementReportType = measurementReportType
    this.measurementReportFormat = measurementReportFormat
    await this.openDialogReport()
  }

  async openDialogReport () {
    const bodyRequest = { ...this.measurementReportParams, relFormatoRelatorio: this.relFormatoRelatorio }
    const repoForm = await this.fetchMeasureamentReport(bodyRequest)
    repoForm[0].dadosForm = { ...repoForm[0].dadosForm, ...bodyRequest }
    this.measurementReportForm = repoForm
    this.visible = false
  }

  async fetchMeasureamentReport (bodyRequest) {
    if (this.measurementReportParams && this.measurementReportParams.contractBillingType === 20560005) {
      if (this.measurementReportType === this.$gettext('SYNTHETIC')) {
        return await repository.resolve('industrialMovementMeasurementSyntheticReport.industrialMovementMeasurementSyntheticReport', bodyRequest)
      } else {
        return await repository.resolve('industrialMovementMeasurementReport.industrialMovementMeasurementReport', bodyRequest)
      }
    }
    return await repository.resolve('billingOrderSendMeasurementReport.billingOrderSendMeasurementReport',
      bodyRequest
    )
  }

  get page () {
    return BillingOrderPage
  }

  get pageSearch () {
    return BillingOrderPageSearch
  }

  get relFormatoRelatorio () {
    return this.measurementReportFormat === 'pdf' ? 1 : 3
  }
}
export default BillingOrder
</script>
<style lang="stylus" scoped></style>
